(() => {
  const bound = new WeakSet();
  function init(scope = document) {
    scope.querySelectorAll('[data-ph44-donation]').forEach(form => {
      if (bound.has(form)) return;
      bound.add(form);
      const select = form.querySelector('[data-amount-select]');
      const buttons = [...form.querySelectorAll('[data-variant]')];
      const feeRow = form.querySelector('[data-offset-row]');
      const feeChoice = form.querySelector('[data-offset-choice]');
      const errorBox = form.querySelector('[data-checkout-error]');
      const submit = form.querySelector('[type=submit]');
      let busy = false;
      const refresh = () => {
        const opt = select.selectedOptions[0];
        buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.variant === select.value)));
        if (feeRow) {
          feeRow.hidden = !opt?.dataset.offset;
          if (feeRow.hidden) feeChoice.checked = false;
          form.querySelector('span[data-offset-label]').textContent = opt?.dataset.offsetLabel || '';
        }
      };
      form.querySelector('[data-amount-buttons]').hidden = false;
      select.addEventListener('change', refresh);
      buttons.forEach(button => button.addEventListener('click', () => {
        if (busy) return;
        select.value = button.dataset.variant;
        refresh();
      }));
      const deskParam = new URLSearchParams(location.search).get('desk');
      const deskSelect = form.querySelector('[data-desk]');
      const deskOption = [...deskSelect.options].find(option => option.value.toLowerCase() === deskParam?.toLowerCase());
      if (deskOption) deskSelect.value = deskOption.value;
      refresh();
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (busy || !form.reportValidity()) return;
        busy = true;
        submit.disabled = true;
        form.setAttribute('aria-busy', 'true');
        errorBox.hidden = true;
        const properties = {};
        for (const [key, value] of new FormData(form)) {
          const match = key.match(/^properties\[(.+)\]$/);
          if (match && value) properties[match[1]] = value;
        }
        const items = [{ id: select.value, quantity: 1, properties }];
        const feeId = select.selectedOptions[0]?.dataset.offset;
        if (feeChoice?.checked && feeId) items.push({ id: feeId, quantity: 1, properties: { 'For field gift': select.value } });
        try {
          const response = await fetch(form.dataset.root + 'cart/add.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items })
          });
          const result = await response.json();
          if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : form.dataset.error);
          // No cart clear: any existing merchandise remains in the customer's cart.
          location.assign(form.dataset.root + 'checkout');
        } catch (error) {
          errorBox.textContent = error.message || form.dataset.error;
          errorBox.hidden = false;
          errorBox.focus();
          busy = false;
          submit.disabled = false;
          form.removeAttribute('aria-busy');
        }
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();